import styles from "@src/components/Buttons/style.module.scss";

export const Button =({color, theme, text, onClick, loading, bind}: any)=> {
    return (
        <button {...bind?bind:{}} disabled={loading} className={`${styles[theme]} ${styles[color]} button`} onClick={onClick}>
            {text}
        </button>
    )
}
